import { render, staticRenderFns } from "./Consultarfarmaco.vue?vue&type=template&id=7d015feb"
import script from "./Consultarfarmaco.vue?vue&type=script&lang=js"
export * from "./Consultarfarmaco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports